import { createFileRoute } from '@tanstack/react-router';
import { CasinoCategoryPage } from '@/ui/casino';

export const Route = createFileRoute('/livecasino/')({
  component: LiveCasinoPage,
});

function LiveCasinoPage() {
  return <CasinoCategoryPage category="livecasino" liveMode title="Live Casino" />;
}
